module.exports = __webpack_public_path__ + "img/jupiter.b7290487.png";